var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.through)?_c('el-button',{attrs:{"type":_vm.type,"size":_vm.size,"plain":_vm.plain,"round":_vm.round,"circle":_vm.circle,"loading":_vm.loading,"disabled":_vm.disabled,"icon":_vm.icon,"autofocus":_vm.autofocus},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.text))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }